<script setup lang="ts">
import { ref, provide } from 'vue';
import { RouterView } from 'vue-router';
import PageHeader from '@@summit/2023/components/PageHeader.vue';
import PageFooter from '@@summit/2023/components/PageFooter.vue';

const appClass = ref('');

provide('app-class', appClass);
</script>

<template>
  <div class="page-app bg-top bg-no-repeat" :class="[appClass]">
    <PageHeader />
    <RouterView />
    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
.page-app {
  background-color: #f2f2f5;
  background-image: url(@@summit/2023/assets/common/bg.svg);

  &.journalism-detail {
    background-color: #fff;
    background-image: url(@@summit/2023/assets/common/detail-bg.svg);
    background-size: cover;
  }
}
</style>
